/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-09 15:07:28
 */
export default {
  lang: "英语English",
  detail: {
    name1: "telephone",
    name2:"consult",
    name4:"Commodity",
    name5:"Details",
    name6:"Distribution",
    name7:"Selected",
    name8:"Purchase",
    name9:"Open CarlcareAPP to Purchase",
    name10:"Sales promotion",
    name11:"Product Details",
    name12:"First Order Discount",
    name13:"Promotion",
    name14:"",
  }
};
